export const initials = (firstName, lastName) =>
  `${(firstName || '').charAt(0)}${(lastName || '').charAt(0)}`.toUpperCase() || 'U';

export const formatPhone = (phone) => {
  if (!phone) return '';
  const digits = phone.replace(/\D/g, '');
  if (digits.length === 11 && digits.startsWith('1')) {
    return `+1 (${digits.slice(1, 4)}) ${digits.slice(4, 7)}-${digits.slice(7)}`;
  }
  if (digits.length === 10) {
    return `+1 (${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
  }
  return phone;
};

export const maskPhone = (digits) => {
  if (!digits) return '';
  const last2 = digits.slice(-2);
  return `${'*'.repeat(Math.max(0, digits.length - 2))}${last2}`;
};

/**
 * Map a user `status` to a display label + Tailwind badge classes. Used by the
 * Team Members panel + Edit Member drawer (Activate / Deactivate flow).
 */
export const formatMemberStatus = (status) => {
  const s = (status || '').toUpperCase();
  switch (s) {
    case 'ACTIVE':               return { label: 'Active',             className: 'bg-green-100 text-green-700' };
    case 'INACTIVE':             return { label: 'Deactivated',        className: 'bg-gray-100 text-gray-700' };
    case 'ONBOARDING_COMPLETED': return { label: 'Pending Activation', className: 'bg-amber-100 text-amber-700' };
    case 'ONBOARDING_STARTED':   return { label: 'Under Review',       className: 'bg-amber-100 text-amber-700' };
    case 'SUSPENDED':            return { label: 'Suspended',          className: 'bg-red-100 text-red-700' };
    case 'ARCHIVED':             return { label: 'Archived',           className: 'bg-red-100 text-red-700' };
    default:                     return { label: status || 'Unknown',  className: 'bg-gray-100 text-gray-700' };
  }
};
